import Card from "Components/card/Card";
import SendInquiryForm from "Components/form/SendInquiryForm";
import React from "react";
import { useSupplierContext } from "..";

type Props = {};

const ContactUsTab = (props: Props) => {
  const { supplierDetail } = useSupplierContext();
  return (
    <Card>
      <SendInquiryForm supplierData={supplierDetail} />
    </Card>
  );
};

export default ContactUsTab;
